import { render, staticRenderFns } from "./unresolved_discussions.vue?vue&type=template&id=c1203020"
import script from "./unresolved_discussions.vue?vue&type=script&lang=js"
export * from "./unresolved_discussions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports